const commonEn = {
  en: {
    common: {
      language: {
        en: 'English',
        zh: '中文',
        ja: '日本語',
        kr: '한국어',
      },
      logout: 'Log Out',
      change_password_button: 'Change Password',
      my_plan: 'My Plan',
      my_profile: 'My Profile',
      message_box: 'Message Box',
      faq: 'FAQ',
      contact_us: 'Contact Us',
      today: 'Today',
      reset: 'Reset',
      submit: 'Submit',
      search: 'Search',
      stage: 'Stage',
      status: 'Status',
      type: 'Type',
      consultant: 'Partner',
      search_rec_date: 'Appl. Received Date (YYYY/MM/DD)',
      search_create_date: 'Created Date (YYYY/MM/DD)',
      search_complete_date: 'Completion Date (YYYY/MM/DD)',
      included_team: 'Include Team',
      documents: {
        title: 'List of Document',
        no_file_found: 'No file found',
      },
      loading: 'Processing...',
      sortable_column: 'Sortable column',
      please_select: 'Please Select',
      close: 'Close',
      pdf_version: 'PDF version',
      zip_version: 'ZIP',
      expand_tree: 'Expand',
      collapse_tree: 'Collapse',
      pop_error: 'Notification',
      main_site_contact_us: 'CONTACT US',
      main_site_privacy: 'PRIVACY',
      main_site_disclaimer: 'DISCLAIMER',
      react_select_placeholder: 'Select...',
      per_page: 'per page',
      paginate_status: 'view {{from}} - {{to}} of {{size}}',
      cannot_be_blank: 'Cannot be blank',
    },
    models: {
      applications: {
        code: 'Code',
        name: 'Name',
        action_type: 'Action type',
        product_provider: 'Product provider',
        product_type: 'Product type',
        product_name: 'Product name',
        has_riders: 'With riders',
      },
      applicant: {
        given_name: 'Given Name',
        birth_on: 'Date of birth',
      },
    },
    selection: {
      included_team: [['true', 'Yes'], ['false', 'No']],
      stage_type: [
        ['nb', 'In Progress'],
        ['all', 'All'],
        ['select', 'Customize'],
      ],
      stage_options: [
        ['', '- All -'],
        [1, 'Stage 1'],
        [2, 'Stage 2'],
        [3, 'Stage 3'],
        [4, 'Stage 4'],
        [5, 'Stage 5'],
        [6, 'Stage 6'],
        [7, 'Stage 7'],
        [8, 'Other'],
      ],
      stage_options_by_site: {
        'afs':
        [
          ['', '- All -'],
          [1, 'Stage 1'],
          [2, 'Stage 2'],
          [3, 'Stage 3'],
          [4, 'Stage 4'],
          [5, 'Stage 5'],
          [6, 'Stage 6'],
          [7, 'Stage 7'],
          [8, 'Other'],
        ],
        'ipc':
        [
          ['', '- All -'],
          [1, 'Stage 1'],
          [2, 'Stage 2'],
          [3, 'Stage 3'],
          [4, 'Stage 4'],
          [5, 'Stage 5'],
          [6, 'Stage 6'],
          [7, 'Stage 7'],
          [8, 'Other'],
        ],
        'absg':
        [
          ['', '- All -'],
          [3, 'Stage 3'],
          [7, 'Stage 7'],
          [8, 'Other'],
        ],
      },
      followup_type_options: [
        ['', ' - All - '],
        [6, 'Missing Premium'],
        [7, 'Renewal'],
      ],
      type_options: [
        ['', ' - All - '],
        ['D', 'Discretionary'],
        ['N', 'Non-Discretionary'],
        ['T', 'TR-Discretionary'],
      ],
      report_date_options: [
        ['APPL', 'Appl. Rec. Date'],
        ['APPLSENT', 'Appl. Sent Date'],
        ['POLICY', 'Commencement Date'],
      ],
      client_date_options: [
        ['APPL', 'Appl. Rec. Date'],
        ['POLICY', 'Commencement Date'],
      ],
      report_type_options: {
        'afs':
        [
          [1, '1. Lapsed / Surrender Report'],
          [2, '2. New Client Report'],
          [3, '3. New Business Status Report'],
          [4, '4. Sales Performance Report'],
          [5, '5. Transfer In Report'],
          [6, '6. Client Birthday Report'],
          [7, '7. Missing Premium Report'],
          [8, '8. Credit Card Expiry Report'],
          [9, '9. Client Portfolio Report'],
          [10, '10. Policy Summary Report'],
          [11, '11. Policy Item Details Report'],
          [12, '12. Policy Owner Report'],
          [13, '13. Policy AB BV Report'],
          [14, '14. Personal AB BV Report'],
          [201, '201. Training History Report'],
        ],
        'ipc':
        [
          [1, '1. Policy Summary Report'],
          [2, '2. Policy Item Details Report'],
          [3, '3. Policy Owner Report'],
          [4, '4. Sales Performance Report'],
          [5, '5. Client Birthday Report']
        ],
        'absg':
        [
          [2, '1. Policy Item Details Report'],
          [3, '2. Policy Owner Report'],
        ]
      },
      month_options: [
        [1, '1'],
        [2, '2'],
        [3, '3'],
        [4, '4'],
        [5, '5'],
        [6, '6'],
        [7, '7'],
        [8, '8'],
        [9, '9'],
        [10, '10'],
        [11, '11'],
        [12, '12'],
      ],
      product_type_options: [
        ['', '- All -'],
        ['IL', 'ILAS'],
        ['IN', 'Insurance Plan'],
      ],
      exclude_status_options: [
        ['CAN', 'Cancelled'],
        ['COF', 'Cooled Off'],
        ['LAP', 'Lapsed'],
        ['SUR', 'Surrendered'],
        ['TOT', 'Transferred Out'],
      ],
      participating_policy_options: [
        ['', ''],
        ['Y', 'Yes'],
        ['N', 'No'],
      ],
      lapsed_surrender_options: [
        ['', '- All -'],
        ['LAP', 'Lapsed'],
        ['SUR', 'Surrendered'],
      ],
      status_options: [['All', 'All'], ['O', 'Open'], ['C', 'Closed']],
      policy_status: [
        ['RCV', 'Received'],
        ['AIP', 'In Progress'],
        ['ACT', 'Accepted'],
        ['CAN', 'Cancelled'],
        ['INF', 'Inforce'],
        ['COF', 'Cooled Off'],
        ['MAT', 'Matured'],
        ['LAP', 'Lapsed'],
        ['SUR', 'Surrendered'],
        ['TOT', 'Transferred Out'],
        ['OPN', 'Account Open'],
        ['CFM', ''],
        ['TER', 'Terminated'],
        ['COD', 'Account Close'],
      ],
      exclude_policy_status: [
        ['COD', 'Account Close'],
        ['CAN', 'Cancelled'],
        ['COF', 'Cooled Off'],
        ['LAP', 'Lapsed'],
        ['SUR', 'Surrendered'],
        ['TOT', 'Transferred Out'],
        ['TER', 'Terminated'],
      ],
      product_type: [
        ['IL', 'ILAS'],
        ['IN', 'Insurance Plan'],
        ['FD', 'Investment'],
        ['GI', 'General Insurance'],
        ['MPF', 'MPF'],
        ['PB', 'Private Bank'],
        ['TU', 'Trust'],
      ],
      b2b_product_type: [
        ['IL', 'ILAS'],
        ['IN', 'Insurance Plan'],
        ['FD', 'Investment'],
        ['GI', 'General Insurance'],
        ['MPF', 'MPF'],
        ['PB', 'Private Bank'],
        ['TU', 'Trust'],
      ],
      applicants: {
        1: '1st Applicant',
        2: '2nd Applicant',
        3: '3rd Applicant',
        4: '4th Applicant',
        5: '5th Applicant',
      },
      yes_no: {
        1: 'Yes',
        0: 'No',
      },
      product_action: {
        NB: 'New Application',
        PI: 'Premium Increase',
        TI: 'Transfer-In',
        AM: 'Assignment',
      },
      product_provider: {
        AIA: 'AIA International Limited',
        Blue: 'Blue Insurance Limited',
        AXA: 'AXA China Region Insurance Company Limited',
        Chubb: 'Chubb Life Insurance Company Ltd.',
        FPI: 'Friends Provident International Limited',
        FWD: 'FWD Life Insurance Company (Bermuda) Limited',
        Generali: 'Generali Worldwide Insurance Company Limited',
        Zurich: 'Zurich International Life Limited',
        Manulife: 'Manulife (International) Limited',
        MassMutual: 'MassMutual Asia Ltd.',
        MetLife: 'MetLife Limited',
        Prudential: 'Prudential Hong Kong Limited',
        Tranamerica: 'Transamerica Life (Bermuda) Ltd.',
        iFast: 'iFAST Financial (HK) Limited',
        'BoC Life': 'BOC Group Life Assurance Company LTD.',
        'China Life': 'China Life Insurance (Overseas) Co. Ltd.',
        'CTF Life': 'Chow Tai Fook Life Insurance Company Limited',
        'Hengansl': 'Heng An Standard Life (Asia) Limited',
        'Sun Life': 'Sun Life Hong Kong Limited',
        'RL 360': 'RL360 Insurance Company Limited',
      },
    },
    login: {
      select_area: 'Please Select :',
      select_client: 'Client Login',
      select_producer: 'Partner Login',
      login_btn: 'Login',
      login: 'Client ID',
      login_b2b: {
        afs: 'Login ID',
        ipc: 'Login ID',
        absg: 'Advisor Code'
      },
      otp_code: 'OTP Code',
      otp_btn: 'Submit',
      password: 'Password',
      loginHelpB2c: 'Your ID is an 8 digital number provided start with “AG” e.g. AG12345678',
      passwordHelpB2c: 'Password is 6 to 10 characters',
      loginWording: 'By accessing this login area you agree that you have accepted the terms of our ',
      disclaimer: 'disclaimer',
      and: ' and ',
      privacyPolicy: 'privacy policy',
      loginWording2: '',
      newUser: 'New User?',
      activateYourAccount: 'Activate Your Account',
      newUser2: '',
      cannotLogin: 'Cannot Login?',
      cannotLogin_b2b: 'Cannot Login?',
      forgetLoginIdPassword: 'Forget Client ID / Password',
      cannotLogin2: '',
      forgetPassword: 'Forget Password',
      needHelp: 'Need Help?',
      needHelpPlease: 'Need Help? Please ',
      faq_1: 'View the',
      faq_2: ' FAQ ',
      faq_3: 'for Account registration and login',
      needAssistant: 'If you need assistance, please',
      contactUs: ' Contact Us',
      inquiry_1: '',
      inquiry_2: '',
    },
    activation: {
      login_id: 'Client ID',
      identification_number: 'Identification Number',
      identification_number_placeholder: 'ID / Passport / BR Number / AGXXXXXXXX',
      identification_number_tooptip_text: 'Please refer to the Client ID (AGxxxxxx) stated on the Welcome Letter or your valuation statement.',
      date_of_birth: 'Date of Birth/Date of Incorporation',
      code: 'Activation Code',
      new_password: 'Password',
      password_confirmation: 'Re-enter password',
      submit: 'Submit',
      online_reg_title: 'Online Registration',
      reg_sub_title: 'Identify Verification',
      reg_form_head_title: 'Please enter your information',
      dd: 'DD',
      mm: 'MM',
      yyyy: 'YYYY',

      with_email: {
        sub_title: 'Activation link has been sent!',
        content_line1: 'An Activation link has been sent to your registered email address {{email}},',
        content_line2: 'Please follow the instruction in the email to complete the registration.',
        content_line3: 'if you do not receive our email in the next 30 minutes,',
        content_line4: 'please click the below button and we will send it again.',
      },
      without_email: {
        sub_title: 'Email not found',
        content_line1: 'The email address you provided does not match our records. To troubleshoot, please provide your ',
        content_line2: 'email address by completing ',
        content_form_name: '"Change of Contact Details Form"',
        content_line3: 'and email it to ',
        content_line4: 'For any inquiries, you can contact your consultant or',
        content_line5: ' click here',
      },

      activate_sub_title: 'Personalize your password before moving forward.',
      activate_success_sub_title: 'Online registration is successfully completed!',
      activate_success_content_line1: 'Your Athena Best Online Account has been created.',
      activate_success_content_line2: 'Please remember your Client ID {{loginId}} for login purpose.',
      go_to_login: 'Go to Login Page',
      send_again: 'Send Again',
    },
    forget_password: {
      login_id: 'Client ID',
      login_id_b2b: 'Login ID',
      identification_number: 'Identification Number',
      identification_number_placeholder: 'ID / Passport / BR Number / AGXXXXXXXX',
      identification_number_tooptip_text: 'Please refer to the Client ID (AGxxxxxx) stated on the Welcome Letter or your valuation statement.',
      date_of_birth: 'Date of Birth/Date of Incorporation',
      code: 'Activation Code',
      submit: 'Submit',
      title: 'Forget Client ID / Password',
      title_b2b: 'Forget Password',
      sub_title: 'Identify Verification',
      form_head_title: 'Please enter your information',
      form_head_title_b2b: 'Please enter your information',
      go_to_login: 'Go to Login Page',
      send_again: 'Send Again',
      dd: 'DD',
      mm: 'MM',
      yyyy: 'YYYY',

      with_email: {
        sub_title: 'Activation link has been sent!',
        content_line1: 'An Activation link has been sent to your registered email address {{email}},',
        content_line2: 'Please follow the instruction in the email',
        content_line3: 'if you do not receive our email in the next 30 minutes,',
        content_line4: 'please click the below button',
      },
      without_email: {
        sub_title: 'Email not found',
        content_line1: 'The email address you provided does not match our records. To troubleshoot, please provide your ',
        content_line2: 'email address by completing ',
        content_form_name: '"Change of Contact Details Form"',
        content_line3: 'and email it to ',
        content_line4: 'For any inquiries, you can contact your consultant or',
        content_line5: ' click here',
      },
      reset_password: {
        title: 'Forget Client ID / Password',
        title_b2b: 'Forget Partner Password',
        sub_title: 'Reset your password before moving forward.',
        login_id: 'Client ID',
        login_id_b2b: 'Login ID',
        new_password: 'Password',
        password_confirmation: 'Re-enter password',
        code: 'Activation Code',
      },
      reset_success: {
        sub_title: 'Your request is successfully completed!',
        content_line1: 'Your password has been reset',
        content_line2:
          'Please remember your Client ID {{loginId}} for login purpose.',
      },
    },
    change_password: {
      label: 'Change Password',
      description: '* Password must be 6 to 10 characters',
      current: 'Current Password',
      new: 'New Password',
      confirm_new: 'Confirm New Password',
      success_message: 'Your password has been changed successfully.',
    },
    statement: {
      total_portfolio_value_alert:
        '商品プロバイダーからのデータ提供にて不具合が生じた為、運用報告書が表示できておりません。 ご迷惑をおかけして申し訳ございませんが、問題が解決するまで暫くお時間頂戴できます様お願い致します。',
    },
    report: {
      reports: 'Reports',
      product_type: 'Product Type',
      exclude: 'Exclude',
      participating_policy: 'Participating Policy',
      month: 'Month',
      type: 'Type',
      to: 'to',
      lapsed_surrender_date: 'Lapsed / Surrender Date (YYYY/MM/DD)',
      transfer_in_effective_date: 'Transfer-in Effective Date (YYYY/MM/DD)',
      sr_created_date: 'Service Records Created Date (YYYY/MM/DD)',
      cc_expiry_date: 'Credit Card Expiry Date (YYYY/MM)',
      received_date: 'Received Date (YYYY/MM/DD)',
      date_attened: 'Date Attened (YYYY/MM/DD)',
      export: 'Export to Excel',
    },
  },
};

export default commonEn;
